import { styled } from "@mui/material";
import React from "react";
import Button from "./Button";

interface ComponentProps {
    props: {
        firstName: string;
        secondName: string;
        buttonText?: string;
    };
    handleOpen?: () => void;
    routeText?: string;
    routeIcon?: React.ReactNode;
    children?: React.ReactNode;
    marginBlockEnd?: string;
}

const Header: React.FC<ComponentProps> = ({ props, handleOpen, children, marginBlockEnd }) => {
    return (
        <StyledContainer marginBlockEnd={marginBlockEnd}>
            <LeftWrapper>
                <FirstText>{props.firstName}</FirstText>
                <div>
                    <SecondText>{props.secondName}</SecondText>
                    {children}
                </div>
            </LeftWrapper>
            {
                props.buttonText &&
                <Button text={props.buttonText} onClick={handleOpen}/>
            }
            
        </StyledContainer>
    )
}

export default Header;

interface ContainerProp {
    marginBlockEnd?: string;
}

const StyledContainer = styled('div')<ContainerProp>`
    display: flex;
    justify-content: space-between;
    margin-block-start: 48px;
    margin-inline: 48px;
    margin-block-end: 0px;
    
`
const LeftWrapper = styled('div')`
    display: flex;
    flex-direction: column;

    & div {
        display: flex;
        //flex-direction: column;
        //align-items: center;
        gap: 10px;
    }
`

const FirstText = styled('span')`
    font-weight: 500;
    line-height: 14px;
    color: #4E5A62;
    font-size: 14px;
`

const SecondText = styled('span')`
    font-weight: 600;
    font-size: 32px;
    
`

